import React, { useMemo, useState } from "react";
import {
  getAIVocies,
  getVoiceFromValue,
} from "../../../../constants/scriptConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setOpenAiVoiceId } from "../../../../store/script/scriptSlice";
import { setElevenLabsVoice } from "../../../../store/slides/slidesSlice";

const OpenAiVoice = ({ onClose, onVoiceSelected, useAi }) => {
  const dispatch = useDispatch();

  const { currentSlideIndex, slides } = useSelector((state) => state.slides);
  const { selectedSlideData } = useSelector((state) => state.script);
  const { isFaceless } = useSelector((state) => state.project);

  const currentSlide = useMemo(() => {
    return useAi
      ? slides[selectedSlideData?.currentSelectSlide || 0]
      : slides[currentSlideIndex];
  }, [currentSlideIndex, slides, selectedSlideData]);

  const elevenLabs = useMemo(
    () => currentSlide?.elevenlabs_voice,
    [currentSlide]
  );

  const { voice, avatarGender } = useMemo(() => {
    let avatar = (currentSlide.objects || []).find(
      (obj) => obj.type === "avatar"
    );
    if (useAi && !avatar) {
      avatar = { gender: getVoiceFromValue(selectedSlideData.voice).gender };
    }
    return {
      voice: useAi
        ? (
            selectedSlideData?.elevenLabVoice?.languageId ||
            selectedSlideData.voice
          )?.slice(0, 5)
        : currentSlide.voice?.slice(0, 5) || "en-US",
      avatarGender: (avatar?.gender || "").toLowerCase() || "male",
    };
  }, [currentSlide, selectedSlideData]);

  const {
    elevenLabsVoice,
    elevenLabsGender,
    elevenLabsAccents,
    elevenLabsAges,
    openAiVoiceId,
  } = useSelector((state) => state.script);
  const { audioSubTab } = useSelector((state) => state.ui);

  console.log("openAiVoiceId", openAiVoiceId);

  return (
    <div className="flex w-full h-full">
      <div className="px-2 pr-0 py-4 w-[100%] bg-gray-100 overflow-auto">
        <div className="pb-1 h-full">
          <div
            htmlFor="scriptInput"
            className="w-full mb-4 text-sm text-gray-700 flex items-center"
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              onClick={onClose}
              className="mr-2 p-1 h-4 border-gray-500 border rounded-lg cursor-pointer"
            />
            <span className="text-gray-500 cursor-pointer" onClick={onClose}>
              {" "}
              BACK{" "}
            </span>
            <span className="font-bold ml-4">Choose Open AI Voices</span>
          </div>

          <div className="w-[100%]">
            <span className="w-full mb-4 text-sm text-gray-700 flex items-center">
              You will have to select the voice name from the drop down list and
              then click Select and then Click Generate Voice to hear the voice.
              The OpenAI API supports all major spoken languages
            </span>
          </div>

          <div className="flex space-x-2 items-end">
            <label className="text-sm mb-2">Select Voice</label>

            <select
              //   defaultValue={}
              onChange={(e) => {
                const value = e.target.value;
                onVoiceSelected(value);

                // dispatch(o)
              }}
              className="w-1/4 p-2 border border-gray-300 text-xs rounded-lg"
            >
              {getAIVocies.map((voice, index) => (
                <option key={index} value={voice.value}>
                  {voice.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenAiVoice;
